import axios from 'axios';
import ConfigAxios from './ConfigAxios';

const getAllOrders = () => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/t1-comercios/orders', options);
};

const getOrderById = (dataClientId, storeCode) => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/t1-comercios/orders/'+storeCode+'/code/' + dataClientId , options);
};

const resendOrder = dataOrder => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.post(NERTHUS + '/t1-comercios/orders/send', dataOrder, options);
};

const createOrder = dataClient => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.post(NERTHUS + '/clients', dataClient, options);
};

const updateOrder = (dataClient, dataClientId) => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.post(NERTHUS + '/users/login/', dataClient, options);
};

const deleteOrder = dataClientId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.delete(NERTHUS + '/clients/code/' + dataClientId, options);
};

const OrderCrudService = {
  getAllOrders,
  getOrderById,
  resendOrder,
  createOrder,
  updateOrder,
  deleteOrder
};

export default OrderCrudService;